import * as React from 'react'
import { useRouter } from 'next/router'
import { NextSeo, BreadcrumbJsonLd, CourseJsonLd } from 'next-seo'

import Routes, { toAbsoluteUrl } from 'utils/routes'
import { Track } from 'types/types'

const SEO = ({ course }: { course: Track }) => {
    const router = useRouter()

    const keywords = [
        'corso di programmazione gratis',
        'diventare programmatore',
        ...course.categories.map((c) => c.title),
    ]

    return (
        <>
            <NextSeo
                title={course.title}
                titleTemplate={'%s | Devv'}
                description={course.long_description}
                canonical={`${toAbsoluteUrl(router.asPath)}`}
                additionalMetaTags={[
                    {
                        property: 'keywords',
                        content: keywords.join(', '),
                    },
                ]}
                openGraph={{
                    url: `${toAbsoluteUrl(router.asPath)}`,
                    images: [
                        {
                            url: Routes.OGImageTitleCTA(course.title, 'CORSO GRATIS'),
                            secureUrl: Routes.OGImageTitleCTA(course.title, 'CORSO GRATIS'),
                            type: 'image/png',
                            width: 1200,
                            height: 630,
                            alt: course.title,
                        },
                    ],
                }}
            />
            <BreadcrumbJsonLd
                itemListElements={[
                    {
                        position: 1,
                        name: 'Catalogo Corsi',
                        item: `${toAbsoluteUrl(Routes.Catalog)}`,
                    },
                    {
                        position: 2,
                        name: course.title,
                        item: `${toAbsoluteUrl(Routes.Course(course.slug))}`,
                    },
                ]}
            />
            <CourseJsonLd
                courseName={course.title}
                description={course.short_description}
                provider={{
                    name: 'Devv',
                    url: `${process.env.NEXT_PUBLIC_DEVV_WEBAPP_URL}`,
                }}
            />
        </>
    )
}

export default SEO
